<div class="row"
	 	#row
		[class.single-line]="forceSingleLine || !description"
		[class.double-line]="!forceSingleLine && !!description">
	<div class="main-row">
		<span class="primary">{{ primaryLabel }}</span>
		<span class="separator" *ngIf="secondaryLabel"></span>
		<span class="secondary" *ngIf="secondaryLabel"> {{ secondaryLabel }} </span>
	</div>
	<div class="description-row" *ngIf="!forceSingleLine && description && description.length > 0">
		<span> {{ description?.join(', ') }}</span>
	</div>
</div>

<cp-tooltip [anchor]="row" [delay]="800" [keepOpenWhenMouseIn]="true" [direction]="forceSingleLine ? 'top' : 'right'">
	<div class="row-tooltip" [style.max-width.px]="maxTooltipWidth">
		<div *ngIf="primaryLabel">{{primaryLabel}}</div>
		<div *ngIf="secondaryLabel">{{secondaryLabel}}</div>
		<div *ngFor="let desc of description" class="description-item">{{desc}}</div>
	</div>
</cp-tooltip>
